module.exports = __webpack_public_path__ + "img/lefthua_brown.9345114e.svg";